<template>
  <PBlockUI :blocked="loading" fullScreen />

  <PCard class="min-h-screen">
    <template #content>
      <PFieldset legend="Application Mode">
        <WAppMode />
        <!-- Files list -->
        <div v-if="auditing">
          <div
            class="flex justify-content-center"
            v-if="selectedAuditFile != ''"
          >
            <b>Active Audit File:</b>
            <span class="text-primary ml-2">{{ selectedAuditFile }}</span>
          </div>
          <PPanel
            :loading="loading"
            class="my-3"
            header="Audit files"
            toggleable
          >
            <div
              :key="i"
              class="flex justify-content-start align-items-center my-2"
              v-for="(filename, i) in auditFilesList"
            >
              <div class="my-1">
                <PRadioButton
                  :inputId="`file_${i}`"
                  :value="filename"
                  name="dynamic"
                  v-model="selectedAuditFile"
                />
                <label :for="`file_${i}`" class="cursor-pointer ml-2">{{
                  filename
                }}</label>
              </div>
              <!-- Delete icon -->
              <!-- <PButton
								icon="pi pi-trash"
								rounded
								severity="danger"
								size="small"
								text
								v-tooltip.bottom="`Delete`"
							></PButton>-->
            </div>
            <!-- Upload a new audit file -->
            <PFileUpload
              :maxFileSize="10000000"
              :multiple="false"
              :url="uploadUrl"
              @before-send="onBeforeSend"
              @error="onError"
              @upload="onUpload"
              accept="text/csv"
              chooseLabel="Add file"
              class="mt-3"
              invalidFileSizeMessage="File size should be less than 10MB"
              invalidFileTypeMessage="Invalid file type. Please upload a CSV file"
              label="Upload CSV File"
              mode="basic"
              name="audit_file"
              size="small"
            />
          </PPanel>
        </div>
        <!-- Coefficients section -->
        <div>
          <PPanel
            :loading="loading"
            class="my-3"
            header="Coefficients settings"
            toggleable
            v-if="auditing && auditFilesList.length > 0"
          >
            <!-- A1, B1, C1 -->
            <div class="formgrid grid">
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="a1">A1</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="a1"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="a1"
                ></PInputNumber>
              </div>
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="b1">B1</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="b1"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="b1"
                ></PInputNumber>
              </div>
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="c1">C1</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="c1"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="c1"
                ></PInputNumber>
              </div>
            </div>
            <!-- Ai, Bi, Ci -->
            <div class="formgrid grid">
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="ai">Ai</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="ai"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="ai"
                ></PInputNumber>
              </div>
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="bi">Bi</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="bi"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="bi"
                ></PInputNumber>
              </div>
              <div class="field col flex flex-column my-2 gap-1">
                <label class="text-primary-50 mb-0" for="ci">Ci</label>
                <PInputNumber
                  :maxFractionDigits="50"
                  :minFractionDigits="0"
                  :useGrouping="false"
                  autocomplete="off"
                  id="ci"
                  mode="decimal"
                  size="small"
                  style="width: 200px"
                  v-model="ci"
                ></PInputNumber>
              </div>
            </div>
          </PPanel>
        </div>
        <!-- lower buttons bar -->
        <div
          class="flex justify-content-between align-items-center"
          v-if="auditing && auditFilesList.length > 0"
        >
          <!-- Generate invoice button -->
          <PSplitButton
            :model="tariffCalculationsButtonItems"
            @click="doTariffCalculations('final')"
            class="mt-3"
            label="Generate Invoice"
            size="small"
            v-if="selectedAuditFile != ''"
          ></PSplitButton>
          <!-- Spinner -->
          <div class="flex align-items-center" v-if="loading">
            {{ generatingInvoiceMessage }}
            <PProgressSpinner
              animationDuration="0.5s"
              class="ml-2"
              strokeWidth="6"
              style="width: 25px; height: 25px"
            />
          </div>
          <!-- Invoice download link -->
          <div
            class="flex align-items-center"
            v-if="invoiceFilename != '' && !loading"
          >
            <PButton
              :label="downloadButtonLabel"
              @click="downloadInvoice()"
              class="mt-3"
              size="small"
              text
            ></PButton>
          </div>
          <!-- </div> -->
          <!-- Save button -->
          <PButton
            @click="saveAuditSettings()"
            class="mt-3"
            label="Save audit settings"
            size="small"
          ></PButton>
        </div>
      </PFieldset>
      <InvoiceChart></InvoiceChart>
    </template>
  </PCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Constants from '@/helpers/Constants';
import PB from '@/brokers/PersistencyBroker';
import EventBus from '@/utils/EventBus';
import store from '@/store';
import WAppMode from '@/components/app_mode/WAppMode.vue';
import Utils from '@/utils/Utils';
import BEBroker from '@/brokers/BEBroker';
import InvoiceChart from '@/components/InvoiceChart.vue';
import _ from 'lodash-es';

export default defineComponent({
  name: 'AppModeView',
  components: {
    WAppMode: WAppMode,
    InvoiceChart,
  },

  data() {
    return {
      component: 'audit_files',
      loading: true,
      auditing: false,
      auditFilesList: [],
      selectedAuditFile: '',
      a1: 0.0,
      b1: 0.0,
      c1: 0.0,
      ai: 0.0,
      bi: 0.0,
      ci: 0.0,
      tpn: '',
      invoiceFilename: '',
      generatingInvoiceMessage: 'Generating invoice ...',
      downloadButtonLabel: 'Download invoice',
      tariffCalculationsButtonItems: [
        {
          label: 'Detailed invoice',
          command: () => this.doTariffCalculations('detailed'),
        },
        {
          label: 'Final invoice',
          command: () => this.doTariffCalculations('final'),
        },
      ],
    };
  },

  created() {
    //@ts-ignore
    EventBus.on(Constants.EVENTS.APP_MODE_CHANGED, this.setAppMode);

    const appMode = PB.get(Constants.LOCAL_STORAGE_IDS.APP_MODE);
    if (appMode && appMode === 'Audit') {
      this.auditing = true;
      store.dispatch('setAppMode', 'Audit');
    } else {
      this.auditing = false;
      store.dispatch('setAppMode', 'Live');
    }
  },

  async mounted() {
    Utils.generatePid(Constants.OPID.READ);
    await this.refreshFilesList();
    this.loading = false;
  },

  computed: {
    uploadUrl() {
      return `${Constants.SERVER_URL}/load_audit_file`;
    },
  },

  methods: {
    setAppMode(appMode: string) {
      this.invoiceFilename = '';
      if (appMode && appMode === 'Audit') {
        this.auditing = true;
        store.dispatch('setAppMode', 'Audit');
      } else {
        this.auditing = false;
        store.dispatch('setAppMode', 'Live');
      }
    },

    /**
     * Add headers to the request
     */
    onBeforeSend(request: any) {
      request.xhr.setRequestHeader(
        'Authorization',
        `Bearer ${store.getters.getAccessToken}`
      );
      return request;
    },

    /**
     * Upload success handler
     */
    async onUpload() {
      await this.refreshFilesList();
      Utils.showSuccessMessage('File uploaded successfully');
    },

    /**
     * Upload failure handler
     */
    async onError(request: any) {
      if (request.xhr.status == 401) {
        Utils.showErrorMessage('Session expired. Please login again');
        store.dispatch('logout');
        this.$router.push({ name: 'Login' });
      } else if (request.xhr.status == 400) {
        const response = JSON.parse(request.xhr.response);
        Utils.showErrorMessage(`Error uploading file: ${response.message}`);
      } else if (request.xhr.status == 500) {
        Utils.showErrorMessage('Error uploading file.');
      }
    },

    /**
     * Refresh the list of audit files
     */
    async refreshFilesList() {
      const res = await BEBroker.get(this.component);
      if (res != null && Object.keys(res).length !== 0) {
        this.auditFilesList = res.files;
        if (this.auditFilesList.length == 1)
          this.selectedAuditFile = this.auditFilesList[0];
        else this.selectedAuditFile = res.active;
        this.a1 = Number(res.a1);
        this.b1 = Number(res.b1);
        this.c1 = Number(res.c1);
        this.ai = Number(res.ai);
        this.bi = Number(res.bi);
        this.ci = Number(res.ci);
      } else {
        this.auditFilesList = [];
        this.selectedAuditFile = '';
        this.a1 = 0.0;
        this.b1 = 0.0;
        this.c1 = 0.0;
        this.ai = 0.0;
        this.bi = 0.0;
        this.ci = 0.0;
      }
    },

    /**
     * Save the audit settings
     */
    saveAuditSettings() {
      this.invoiceFilename = '';
      const payload = {
        active: this.selectedAuditFile,
        a1: this.a1,
        b1: this.b1,
        c1: this.c1,
        ai: this.ai,
        bi: this.bi,
        ci: this.ci,
      };
      BEBroker.saveAuditSettings(this.component, payload);
      Utils.showSuccessMessage('Settings saved successfully');
    },

    /**
     * Perform tariff calculations and generate the invoice
     */
    async doTariffCalculations(mode: string = 'final') {
      this.loading = true;
      const payload = {
        audit_file: this.selectedAuditFile,
        mode: mode,
      };
      this.generatingInvoiceMessage = `Generating ${mode} invoice ...`;
      this.downloadButtonLabel = `Download ${mode} invoice`;
      const res = await BEBroker.performTariffCalculations(
        this.component,
        payload
      );
      this.loading = false;
      if (res != null && Object.keys(res).length !== 0) {
        this.tpn = res.tpn;
        this.invoiceFilename = res.invoice_filename;
        mode = mode.charAt(0).toUpperCase() + mode.slice(1);
        Utils.showSuccessMessage(
          `${mode} invoice has been generated successfully.`
        );
      } else {
        Utils.showErrorMessage('Error while generating the invoice.');
      }
    },

    /**
     * Download the invoice
     */
    downloadInvoice() {
      const payload = {
        filename: this.invoiceFilename,
      };
      window.open(
        `${Constants.SERVER_URL}/download_invoice?comp=invoice&filename=${this.invoiceFilename}`
      );
    },
  },
});
</script>
